<template>
	<div>
		<!-- 菜单导航 -->
		<Menu></Menu>
		<div class="details_main">
			<div class="live-room">
				<div class="breadcrumb">
					<div class="breadcrumb-text">当前位置：<a href="/">首页</a><span>&gt;</span>体验课：{{ data.title }} </div>
				</div>
				<section class="live-container">
					<div class="live-room" v-if="is_ing == 1">
						<div id="live-course" class="live-course">
							<div class="player-content">
								<div class="new-title">
									<div class="new-title-detail">{{ data.title }}</div>
									<div class="new-teacher">
										<div class="head-image-box teacher-head">
											<img :src="data.teacher_thumb"
												style="height: 32px; width: 32px; border-radius: 50%;"
												:alt="data.teacher_name">
										</div>
										<span>老师：{{ data.teacher_name }}</span>
									</div>
								</div>
								<div id="player" class="player show-title"></div>
								<div id="student"></div>
								<div class="chat-room" id="chatRoom"></div>
								<div class="submit-job_btn">
									<div><span class="submit-job_btn-bg">交作业</span></div>
								</div>
							</div>
						</div>
					</div>
					<!---->
					<div>
						<div class="commit-success" style="display: none;"></div>
					</div>
				</section>
			</div>
		</div>
		<!-- 底部链接 -->
		<Footer></Footer>
	</div>
</template>
<script>
	import Menu from '@/components/view/Menu'
	import Footer from '@/components/view/Footer'
	export default {
		name: 'activity',
		components: {
			Menu,
			Footer
		},
		data() {
			return {
				is_ing: 2,
				userList: {},
				appId: 'geh9ahi46l', // 保利威appId
				channelId: 3467478, // 频道号
				userId: 0,
				chatData: {}, // 聊天秘钥
				timestamp: "",
				sign: "", // 频道签名
				data: []
			}
		},
		created() {
			if (this.$cookieStore.getCookie('userInfo')) {
				this.userInfo = JSON.parse(this.$cookieStore.getCookie('userInfo'))
			}
			this.getLive()
		},
		methods: {
			getLive() {
				this.$axios({
					method: 'post',
					url: '/api/live/PublicLive',
					headers: {
						token: this.$cookieStore.getCookie('token')
					},
					data: {
						channel_id: this.channelId
					}
				}).then(res => {
					this.data = res.data.data
					if (res.data.data.is_role == 1) {
						// 正常观看
						this.is_ing = 1
						if (res.data.data.is_ing == 1) {
							this.getSign()
						} else {
							this.$message({
								message: '课程未开始或已结束',
								type: 'warning'
							});
							this.$router.push({
								path: "/"
							})
						}
					} else {
						// 无权限
						this.is_ing = 2
						this.$message({
							message: '您没有试听课权限哦~快去找班主任老师开通吧',
							type: 'warning'
						});
						this.$router.push({
							path: "/"
						})
					}
				}).catch(err => {})
			},
			getSign() {
				this.timestamp = new Date().getTime();
				this.$axios({
					method: 'post', // 请求格式
					url: '/api/live/getSign', // 请求路径
					headers: {
						token: this.$cookieStore.getCookie('token')
					},
					data: {
						appId: this.appId, // 账号appId
						channelId: this.channelId, // 频道号
						timestamp: this.timestamp
					}
				}).then(res => {
					this.sign = res.data
					// 初始化直播sdk对象
					const liveSdk = new PolyvLiveSdk({
						channelId: this.channelId,
						sign: res.data,
						timestamp: this.timestamp,
						appId: this.appId,
						user: {
							userId: this.userInfo.id,
							userName: this.userInfo.nickname,
							pic: this.userInfo.avatar_url,
						},
						param4: this.data.id,
						param5: 2
					});
					// 监听频道信息并初始化播放器
					liveSdk.on(PolyvLiveSdk.EVENTS.CHANNEL_DATA_INIT, (event, data) => {
						//第三步：设置直播播放器
						liveSdk.setupPlayer({
							pptEl: "#ppt",
							el: "#player",
							type: "auto",
							controllerPosition: "ppt",
							pptNavBottom: "70px",
							autoplay: true,
							barrage: true,
							switchPlayer: true,
							defaultBarrageStatus: true
						});
					});
					this.getChatData()
				}).catch(err => {

				})
			},
			getChatData() {
				const params = {
					appId: this.appId, // 账号appId
					channelId: this.channelId, // 频道号
					role: "viewer", // 角色,viewer：观看者
					timestamp: new Date().getTime(),
					userId: this.userInfo.id, // 观看者用户Id
				};
				this.$axios({
					method: 'post', // 请求格式
					url: '/api/live/getSign', // 请求路径
					headers: {
						token: this.$cookieStore.getCookie('token')
					},
					data: params
				}).then(res => {
					params.sign = res.data;
					this.$axios({
						method: 'post', // 请求格式
						url: '/api/live/getChatToken', // 请求路径
						headers: {
							token: this.$cookieStore.getCookie('token')
						},
						data: params
					}).then(res => {
						// 初始化聊天室
						const chatroom = new PolyvChatRoom({
							roomId: this.channelId,
							userId: this.userInfo.id,
							nick: this.userInfo.nickname,
							pic: this.userInfo.avatar_url,
							token: JSON.parse(JSON.stringify(res.data)).data.token,
							mediaChannelKey: JSON.parse(JSON.stringify(res.data)).data
								.mediaChannelKey,
							version: "2.0",
							container: "#chatRoom",
							width: '100%',
							height: '100%',
							userType: "slice",
							enableReplay: true,
							showUserList: false,
							enableFlower: false,
							enableLike: false,
							enableAsk: false,
							enableOnlyTeacher: false,
							roomMessage: function(data) {
								// data为聊天室socket消息，当有聊天室消息时会触发此方法
								console.log(data);
							},
						});
					}).catch(err => {
						console.log(err)
					})
				})
			}
		},
	}
</script>

<style>
	.live-room {
		background-color: #000;
		overflow: hidden;
	}

	.breadcrumb {
		margin-bottom: 40px;
		background: #282828;
		color: hsla(0, 0%, 100%, .6);
		font-size: 14px;
		height: 54px;
		line-height: 54px;
		font-size: 16px;
		font-family: PingFangSC-Medium, PingFang SC;
		font-weight: 500;
		text-align: left;
		padding-left: 20px;
	}

	.breadcrumb-text {
		width: 1350px;
		margin: 0 auto;
	}

	.breadcrumb-text a {
		color: hsla(0, 0%, 100%, .6);
	}

	.breadcrumb-text span {
		margin: 0 5px;
	}

	.teacher-head {
		margin-right: 10px;
	}

	.live-room .live-course {
		width: 1350px;
		margin: 0 auto;
	}

	.live-room .live-course .player-content {
		width: 100%;
		position: relative;
		display: -webkit-box;
		display: -ms-flexbox;
		display: flex;
		margin-bottom: 60px;
	}

	.new-title-player-full,
	.new-title {
		position: absolute;
		display: -webkit-box;
		display: -ms-flexbox;
		display: flex;
		color: #fff;
		-webkit-box-align: center;
		-ms-flex-align: center;
		align-items: center;
		-webkit-box-pack: start;
		-ms-flex-pack: start;
		justify-content: flex-start;
		padding: 0 20px;
		-webkit-box-sizing: border-box;
		box-sizing: border-box;
		top: 0;
		left: 0;
		height: 60px;
		background: #333;
		border-radius: 4px 4px 0 0;
	}

	.new-title {
		width: 960px;
	}

	.new-teacher {
		margin-left: auto;
		font-size: 16px;
		display: -webkit-box;
		display: -ms-flexbox;
		display: flex;
		-webkit-box-align: center;
		-ms-flex-align: center;
		align-items: center;
	}

	.text-length-disable,
	.text-length {
		font-size: 13px;
		font-family: PingFangSC-Medium, PingFang SC;
		font-weight: 500;
		margin-left: auto;
	}

	.live-room .live-course .player {
		float: left;
		min-width: 960px;
		height: 570px;
	}

	.show-title {
		margin-top: 60px;
	}

	#student {
		position: absolute;
		z-index: -1;
		visibility: hidden;
	}

	.live-room .live-course .chat-room {
		position: relative;
		margin-left: 20px;
		float: left;
		width: 356px;
		height: 630px !important;
		border-radius: 4px;
		text-align: left;
		background: #333333 !important;
	}

	.polyv-other-msg-quote .polyv-msg-quote {
		border: none;
		background: whitesmoke;
		padding: 5px 10px;
	}

	.polyv-chat-room {
		padding-top: 45px;
	}

	.polyv-user-logo img {
		width: 28px !important;
		height: 28px !important;
	}

	.polyv-chat-room .polyv-msg-content {
		font-size: 14px;
	}

	.polyv-cr-navbar li {
		line-height: 45px !important;
		color: white;
	}

	.polyv-chat-room>.polyv-cr-head {
		background: #333333;
	}

	.polyv-chat-room .polyv-cr-navbar>li.polyv-crn-active {
		color: white;
		font-size: 16px;
	}

	.polyv-chat-room>.polyv-cr-body {


		background: #2D2D2D !important;
	}

	.tab-chat-content {}

	.polyv-chat-room .polyv-chat-input {
		background: #2D2D2D;
	}

	.polyv-chat-room .polyv-chat-input textarea {
		background: #2D2D2D;
		color: white;
		font-size: 13px;
	}

	/* 滚动条修饰 */
	.tab-chat-content::-webkit-scrollbar {
		width: 10px;
	}

	.tab-chat-content::-webkit-scrollbar-track {
		background: rgb(179, 177, 177);
		border-radius: 10px;
	}

	.tab-chat-content::-webkit-scrollbar-thumb {
		background: rgb(136, 136, 136);
		border-radius: 10px;
	}

	.tab-chat-content::-webkit-scrollbar-thumb:hover {
		background: rgb(100, 100, 100);
		border-radius: 10px;
	}

	.tab-chat-content::-webkit-scrollbar-thumb:active {
		background: rgb(68, 68, 68);
		border-radius: 10px;
	}
</style>


// WEBPACK FOOTER //
// src/components/CurriculumDetailslive.vue